import React from 'react';
import { Box, Typography } from '@mui/material';
import { LocationBlack } from './Marketplaceicons';
import { AgentComp } from './AgentComp';

const StickyAddressBar = ({
  isStickyAddress,
  isBinderChatOpen,
  matchessm,
  getBuyerIndividualValue,
  showActivateTrade,
  sharedpage,
  setOpenlogin,
  openlogin,
  directcomm,
  setIsHovered,
  handleMouseLeave,
  handleClick,
  isDialogOpen,
  setDialogOpen,
  anchorEl,
  setAnchorEl,
  isHovered,
  isSticky,
  matcheslg,
}) => {
  if (!isStickyAddress || isBinderChatOpen || matchessm) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 70,
        left: 0,
        right: 0,
        zIndex: 1300,
        background: '#FAFAFA',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 3,
          py: 2,
        }}
      >
        <LocationBlack />

        <Typography
          sx={{
            fontSize: '22px',
            fontFamily: 'poppins',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {
            getBuyerIndividualValue?.PropertyDetails?.propertyAddress
              ?.streetName
          }
        </Typography>
      </Box>
      {!matcheslg && (
        <AgentComp
          isStickyAddress={isStickyAddress}
          showActivateTrade={showActivateTrade}
          getBuyerIndividualValue={getBuyerIndividualValue}
          sharedpage={sharedpage}
          setOpenlogin={setOpenlogin}
          openlogin={openlogin}
          directcomm={directcomm}
          setIsHovered={setIsHovered}
          handleMouseLeave={handleMouseLeave}
          handleClick={handleClick}
          isDialogOpen={isDialogOpen}
          setDialogOpen={setDialogOpen}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          isHovered={isHovered}
          isSticky={isSticky}
        />
      )}
    </Box>
  );
};

export default StickyAddressBar;
